export default {
  setFirstBreadcrumb(state, item) {
    state.items = [
      {
        ...item,
        index: 0,
      },
    ]
  },
  pushItemBreadcrumb(state, item) {
    state.items.push({
      ...item,
      index: state.items.length,
    })
  },
  navBackBreadcrumb(state, key) {
    const index = state.items.findIndex((item) => item.key === key)
    const item = state.items.find((item) => item.key === key)
    if (item?.action) {
      item.action()
    }

    state.items.splice(index + 1)
  },
  popBreadcrumbItem(state) {
    const index = state.items.length - 1
    state.items.splice(index)
  },
  resetBreadcrumb(state) {
    if (state.items.length > 1) {
      state.items.splice(1)
    }
  },
  hardResetBreadcrumb(state) {
    state.items = []
  },
}
